export const toTailwindNumericValue = (prefix, value) => {
  if (String(value.name).startsWith("-")) {
    return `-${prefix}-${value.name.substr(1)}`;
  }

  return `${prefix}-${value.name}`;
};

